import React from 'react';
import {
    Tooltip,
    IconButton,
    Checkbox,
    Box,
    Typography,
    Link,
    Chip,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { createTheme } from '@mui/material/styles';
import CircleIcon from '@mui/icons-material/Circle';
import airSvg from '../../assets/images/airSvg.svg';
import groundSvg from '../../assets/images/sedan_black_small.svg';
import Switch from '@mui/material/Switch';
import Popover from '@mui/material/Popover';
import completedSvg from '../../assets/images/completedSvg.svg';
import notCompletedSvg from '../../assets/images/notCompletedSvg.svg';
import rejectSvg from '../../assets/images/rejectSvg.svg';
import notRejectSvg from '../../assets/images/notRejectSvg.svg';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import ProfileInitial from '../profile/profileInitial';
import Badge from '@mui/material/Badge';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import Stack from '@mui/material/Stack';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FULL_PERMISSION } from '../../constants/Constant';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import Helper from '../../utility/helper';
import IOSOnOffSwitch from '../switchComponent/IOSOnOffSwitch';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ArchiveIcon from '@mui/icons-material/Archive';
import SyncProblemOutlinedIcon from '@mui/icons-material/SyncProblemOutlined';
import SyncDisabledOutlinedIcon from '@mui/icons-material/SyncDisabledOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';  
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    columnContent: {
        display: 'flex',
        //height: 'auto',
        flexWrap: 'wrap',
        // justifyContent: 'flex-start',
        alignItems: 'center',
        // this logic needs to be handle for mobile view
        [theme.breakpoints.only('xs')]: {
            flexBasis: '19%',
        },
    },
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
    },
    wrapTextSmallSize: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '30ch',
        fontSize: 12,
    },
    wrapAll: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary',
    },
    wrapTextFullStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        // overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
        cursor: 'pointer'
    },
}));

const DataListRowItem = (props) => {
    const classes = useStyles();
    const { row, item, index } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);

    const onPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closePopover = () => {
        setAnchorEl(null);
    };
    return (
        <Box
            className={classes.columnContent}
            sx={
                row.label === 'Action'
                    ? {
                        flex: `${row.width}`,
                        justifyContent: {
                            xs: 'flex-start',
                            md: 'flex-end',
                            lg: 'flex-end',
                            sm: 'flex-start'
                        },
                    }
                    : !row.type && row.alignCenter != undefined
                        ? {
                            flex: `${row.width}`,
                            justifyContent: {
                                xs: 'flex-start',
                                md: 'center',
                                lg: 'center',
                                sm: 'flex-start'

                            },
                        }
                        : row.alignLeft != undefined
                            ? {
                                flex: `${row.width}`,
                                justifyContent: 'left',
                            }
                            : row.alignRight != undefined
                            ? {
                                flex: `${row.width}`,
                                justifyContent: 'right',
                            } : {
                                flex: `${row.width}`,
                                justifyContent: 'left',
                            }
            }>
            {row.label === 'checkbox' ? (
                <Checkbox
                    inputProps={{
                        'aria-label': 'Participant',
                    }}
                    checked={item.selected ? item.selected : false}
                    onChange={(event) => props.onCheckSelect(event, index)}
                    // color="secondary"
                    value={row[row.key]}
                    disabled={
                        item.disableRow != undefined ? item.disableRow : false
                    }
                />
            ) : row.label === 'Hidden' ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Checkbox
                            inputProps={{
                                'aria-label': 'Participant',
                            }}
                            checked={item.actualData.hide ? item.actualData.hide : false}
                            onChange={(event) => props.onCheckContactSelect(event, index, item)}
                            // color="secondary"
                            value={row[row.key]}
                            sx={{padding:'0px !important'}}
                        // disabled={
                        //     item.disableRow != undefined ? item.disableRow : false
                        // }
                        />
                    </Box>
            ) : row.label === 'SkipEmail' ? (
                <Tooltip title={row.title ?? ''}>
                    <Checkbox
                        inputProps={{
                            'aria-label': 'Participant',
                        }}
                        checked={row.excludeEmail ? true : false}
                        onChange={(event) =>
                            props.onCustomCheckSelect(event, item)
                        }
                        // color="secondary"
                        value={row[row.key]}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }
                    />
                </Tooltip>
            ) : row.label === 'Send' ? (
                <Button
                    variant="contained"
                    style={{ fontSize: 13 }}
                    onClick={() => props.handleClick()}>
                    Send{' '}
                </Button>
            ) : row.label === 'IsNotification' ? (
                <Tooltip title={row.isNotification ? 'ON' : 'OFF'}>
                    <IconButton
                        onClick={(e) => props.onParticipantToggleChange(e, index, item)}
                    >
                        <IOSOnOffSwitch
                            sx={{
                                m: 1,
                            }}
                            checked={
                                row[row.key] != undefined ? row[row.key] : false
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'ReadAction' ? (
                <>
                    <Tooltip
                        onClick={() => item.actualData?.appNotificationID ? props.handleAppNotificationClick(item.actualData) : null}
                        title={row[row.key] ? 'Read' : 'Unread'}
                        aria-label={row[row.key] ? 'Read' : 'Unread'}>
                        <IconButton color="primary">
                            {row[row.key] ? (
                                <DraftsOutlinedIcon color="primary" />
                            ) : (
                                <MarkunreadOutlinedIcon color="primary" />
                            )}
                        </IconButton>
                    </Tooltip>
                </>
            ) : row.label === 'Action' ? (
                row.key == 'editnote' ? (
                    <>
                        {row[row.key] && row[row.key].trim().length > 0 ? (
                            <>
                                <Tooltip title="Note" aria-label="Note">
                                    <IconButton
                                        color="primary"
                                        onClick={(event) => {
                                            onPopover(event);
                                        }}>
                                        <TextSnippetOutlinedIcon color="primary" />
                                    </IconButton>
                                </Tooltip>
                                <Popover
                                    id={'simple-popover'}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={closePopover}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}>
                                    <Typography sx={{ p: 2 }}>
                                        {row[row.key]}
                                    </Typography>
                                </Popover>
                            </>
                        ) : null}
                        {props.modPermission &&
                            props.modPermission == FULL_PERMISSION ? (
                            <Tooltip title="Edit" aria-label="edit">
                                <IconButton
                                    color="primary"
                                    onClick={() => props.editRow(item)}
                                    disabled={
                                        item.disableRow != undefined
                                            ? item.disableRow
                                            : false ||
                                                props.readOnlyOrHide === 1
                                                ? true
                                                : false
                                    }>
                                    <EditOutlinedIcon
                                        fontSize="small"
                                        color={
                                            item.disableRow != undefined ||
                                                props.readOnlyOrHide === 1
                                                ? 'default'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </>
                ) : row[row.key] == 'Edit' ? (
                    props.modPermission &&
                        props.modPermission == FULL_PERMISSION ? (
                        <>
                            {props.showModuleSetting != undefined &&
                                props.showModuleSetting === true 
                                && props.item.actualData.moduleName !== "Invitations"
                                && props.item.actualData.moduleName !== "MediaCircuit" && props.item.actualData.moduleName !== "ContentCircuit" ? (
                                <Tooltip
                                    title={'Settings'}
                                    onClick={() => props.onModuleSettingClick(item)}>
                                    <IconButton>
                                        <SettingsOutlinedIcon
                                            fontSize="small"
                                            color="primary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                            <Tooltip title="Edit" aria-label="edit">
                                <IconButton
                                    color="primary"
                                    onClick={() => props.editRow(item)}
                                    disabled={
                                        item.disableRow != undefined
                                            ? item.disableRow
                                            : false
                                    }>
                                    <EditOutlinedIcon
                                        fontSize="small"
                                        color={
                                            item.disableRow != undefined
                                                ? 'default'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </Tooltip>

                            {props.showDelete && (
                                <Tooltip title="Delete" aria-label="Delete">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.handleDelete(item)}
                                        disabled={
                                            item.disableRow != undefined
                                                ? item.disableRow
                                                : false
                                        }>
                                        <Badge color="primary">
                                            <DeleteOutlinedIcon
                                                fontSize="small"
                                                color={
                                                    item.disableRow != undefined
                                                        ? 'default'
                                                        : 'primary'
                                                }
                                            />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </>
                    ) : null
                ) : row[row.key] == 'BulkUser' ? (
                    props.modPermission &&
                        props.modPermission == FULL_PERMISSION ? (
                        <>
                        <Box sx={{display:'flex', flexDirection: 'row', gap:1}}>
                            <Button
                                variant="contained"
                                style={{ fontSize: 13 }}
                                startIcon={
                                    <SyncProblemOutlinedIcon fontSize="small" />
                                }
                                onClick={() => props.handleExisting(item)}
                                disabled={props.disableRowButton}
                                >
                                Existing
                            </Button> 
                            <Button
                                variant="contained"
                                style={{ fontSize: 13 }}
                                startIcon={
                                    <SyncDisabledOutlinedIcon fontSize="small" />
                                }
                                onClick={() => props.handleOverride(item)}
                                disabled={props.disableRowButton}
                                >
                                Override
                            </Button>
                            <Button
                                variant="contained"
                                style={{ fontSize: 13 }}
                                startIcon={
                                    <AddCircleOutlineOutlinedIcon fontSize="small" />
                                }
                                onClick={() => props.handleCreateNew(item)}
                                disabled={props.disableRowButton}
                                >
                                Create New
                            </Button>  
                            </Box>
                        </>
                    ): null
                ) : row[row.key] == 'Add Participants' ? (
                    <Tooltip title="Add Participants" aria-label="add">
                        <IconButton
                            color="primary"
                            onClick={() => props.handleAddParticipants(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <GroupAddIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) : row[row.key] == 'Participants' ? (
                    <Tooltip title="View Participants" aria-label="view">
                        <IconButton
                            color="primary"
                            onClick={() => props.handleViewParticipants(item)}
                            disabled={
                                item.disableRow != undefined
                                    ? item.disableRow
                                    : false
                            }>
                            <Badge badgeContent={row.count} color="primary">
                                <PeopleAltIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                ) : props.modPermission &&
                    props.modPermission == FULL_PERMISSION ? (
                    <>
                        <Tooltip title="Approve" aria-label="Approve">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    item.actualData.requestStatus ==
                                        'Pending' ||
                                        item.actualData.requestStatus == 'Rejected'
                                        ? props.onActionClick(item, 'Approve')
                                        : props.onPendingAction(item);
                                }}
                                sx={
                                    item.actualData.requestStatus == 'Pending'
                                        ? { cursor: 'pointer' }
                                        : item.actualData.requestStatus ==
                                            'Approved'
                                            ? { cursor: 'default' }
                                            : { cursor: 'pointer' }
                                }>
                                <Box
                                    component="img"
                                    className={classes.actionIcon}
                                    alt="logo."
                                    src={
                                        item.actualData.requestStatus ==
                                            'Pending'
                                            ? notCompletedSvg
                                            : item.actualData.requestStatus ==
                                                'Approved'
                                                ? completedSvg
                                                : notCompletedSvg
                                    }
                                />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Reject" aria-label="Reject">
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    item.actualData.requestStatus ==
                                        'Pending' ||
                                        item.actualData.requestStatus == 'Approved'
                                        ? props.onActionClick(item, 'Reject')
                                        : props.onPendingAction(item);
                                }}
                                sx={
                                    item.actualData.requestStatus == 'Pending'
                                        ? { cursor: 'pointer' }
                                        : item.actualData.requestStatus ==
                                            'Rejected'
                                            ? { cursor: 'default' }
                                            : { cursor: 'pointer' }
                                }>
                                <Box
                                    component="img"
                                    className={classes.actionIcon}
                                    alt="logo."
                                    src={
                                        item.actualData.requestStatus ==
                                            'Pending'
                                            ? notRejectSvg
                                            : item.actualData.requestStatus ==
                                                'Approved'
                                                ? notRejectSvg
                                                : rejectSvg
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton
                                color="primary"
                                onClick={() => props.editRow(item)}
                                disabled={
                                    item.disableRow != undefined
                                        ? item.disableRow
                                        : false || props.readOnlyOrHide === 1
                                            ? true
                                            : false
                                }>
                                <EditOutlinedIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </>
                ) : null
            ) : row.label === 'Template' ? (
                <Tooltip title="Edit" aria-label="edit">
                    <IconButton
                        color="primary"
                        onClick={() => props.editTemplate(item)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <TextSnippetOutlinedIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'Hotel' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            textAlign={'center'}
                            color="primary">
                            C/P
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            textAlign={'center'}
                            fontWeight={400}>
                            {(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined) ? item.actualData.allotments[0].hotelSetting !== null ? JSON.parse(item.actualData.allotments[0].hotelSetting).comp !== "" ? JSON.parse(item.actualData.allotments[0].hotelSetting).comp + '/' + JSON.parse(item.actualData.allotments[0].hotelSetting).pay : 0 : 0 : 0}
                        </Typography>
                    </Box>
                </>
            ) : row.label === 'FlightInfo' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            Flight Info
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            textAlign={'center'}
                            color="primary">
                            A/D
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            textAlign={'center'}
                            fontWeight={400}>
                            {(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined) ? item.actualData.allotments[0].transportSetting !== null ? JSON.parse(item.actualData.allotments[0].transportSetting).arrival !== "" || JSON.parse(item.actualData.allotments[0].transportSetting).arrival !== undefined ? JSON.parse(item.actualData.allotments[0].transportSetting).arrival + '/' + JSON.parse(item.actualData.allotments[0].transportSetting).departure : 0 : 0 : 0}
                        </Typography>
                    </Box>
                </>
            ) : 
             row.label === 'Complimentary' ? (
                <>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                     <Typography
                         variant="h4"
                         flexGrow={1}
                         fontSize={12}
                         textAlign={'center'}
                         fontWeight={500}
                         color="primary">
                         {row.label}
                     </Typography>
                     <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                         <Box
                             sx={{
                                 display: 'flex',
                                 flexDirection: 'column',
                             }}>
                             <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                 <Box
                                     sx={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                     }}>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         fontSize={12}
                                         textAlign={'center'}
                                         fontWeight={500}
                                         color="primary">
                                         Used
                                     </Typography>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         textAlign={'center'}
                                         fontSize={14}
                                         fontWeight={400}>
                                         {row.hotelSettingData.length > 0
                                             ? (row.hotelSettingRemainingcount !==
                                                 undefined
                                                 ? row
                                                     .hotelSettingRemainingcount[0]
                                                     .comp
                                                 : 0)
                                             : 0}
                                     </Typography>
                                 </Box>
                                 <Divider
                                     orientation="vertical"
                                     flexItem
                                     sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                                 />
                                 <Box
                                     sx={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                     }}>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         fontSize={12}
                                         textAlign={'center'}
                                         fontWeight={500}
                                         color="primary">
                                         Alloted
                                     </Typography>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         textAlign={'center'}
                                         fontSize={14}
                                         fontWeight={400}>
                                         {row.hotelSettingData.length > 0
                                             ?
                                             row.hotelSettingData[0].comp
                                             : 0}
                                     </Typography>
                                 </Box>

                             </Box>
                         </Box>
                         </Box>
                 </Box>
                </>
             ) : row.label === 'For Purchase' ? (
                 <>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                     <Typography
                         variant="h4"
                         flexGrow={1}
                         fontSize={12}
                         textAlign={'center'}
                         fontWeight={500}
                         color="primary">
                         {row.label}
                     </Typography>
                    <Box
                             sx={{
                                 display: 'flex',
                                 flexDirection: 'column',
                             }}>
                             <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                 <Box
                                     sx={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                     }}>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         fontSize={12}
                                         textAlign={'center'}
                                         fontWeight={500}
                                         color="primary">
                                         Used
                                     </Typography>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         textAlign={'center'}
                                         fontSize={14}
                                         fontWeight={400}>
                                         {row.hotelSettingData.length > 0
                                             ? (row.hotelSettingRemainingcount !==
                                                 undefined
                                                 ? row
                                                     .hotelSettingRemainingcount[0]
                                                     .pay
                                                 : 0)
                                             : 0}
                                     </Typography>
                                 </Box>
                                 <Divider
                                     orientation="vertical"
                                     flexItem
                                     sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                                 />
                                 <Box
                                     sx={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                     }}>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         fontSize={12}
                                         textAlign={'center'}
                                         fontWeight={500}
                                         color="primary">
                                         Alloted
                                     </Typography>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         textAlign={'center'}
                                         fontSize={14}
                                         fontWeight={400}>
                                         {row.hotelSettingData.length > 0
                                             ?
                                             row.hotelSettingData[0].pay
                                             : 0}
                                     </Typography>
                                 </Box>
                             </Box>                                 
                         </Box>
             </Box>
                 </>
              )  : row.label === 'Waitlist Request' ? (
                 <>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                     <Typography
                         variant="h4"
                         flexGrow={1}
                         fontSize={12}
                         textAlign={'center'}
                         fontWeight={500}
                         color="primary">
                         {row.label}
                     </Typography>
                    <Box
                             sx={{
                                 display: 'flex',
                                 flexDirection: 'column',
                             }}>
                             <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                 <Box
                                     sx={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                     }}>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         fontSize={12}
                                         textAlign={'center'}
                                         fontWeight={500}
                                         color="primary">
                                         Approved/Alloted
                                     </Typography>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         textAlign={'center'}
                                         fontSize={14}
                                         fontWeight={400}>
                                        {row.approvedcount}
                                     </Typography>
                                 </Box>
                                 <Divider
                                     orientation="vertical"
                                     flexItem
                                     sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                                 />
                                 <Box
                                     sx={{
                                         display: 'flex',
                                         flexDirection: 'column',
                                     }}>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         fontSize={12}
                                         textAlign={'center'}
                                         fontWeight={500}
                                         color="primary">
                                         Pending
                                     </Typography>
                                     <Typography
                                         variant="h4"
                                         flexGrow={1}
                                         textAlign={'center'}
                                         fontSize={14}
                                         fontWeight={400}>
                                        {row.pendingcount}
                                     </Typography>
                                 </Box>
                             </Box>                                 
                         </Box>
                 </Box>
                 </>
              ) :
                 row.label === 'Comp' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            textAlign={'center'}
                            color="primary">
                            Fr/Sa/Su
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            textAlign={'center'}
                            fontSize={14}
                            fontWeight={400}>
                            {(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined) ? item.actualData.allotments[0].ticketSetting !== null ? JSON.parse(item.actualData.allotments[0].ticketSetting).ticketFriCompCount !== "" ? JSON.parse(item.actualData.allotments[0].ticketSetting).ticketFriCompCount + '/' + JSON.parse(item.actualData.allotments[0].ticketSetting).ticketSatCompCount + '/' + JSON.parse(item.actualData.allotments[0].ticketSetting).ticketSunCompCount : 0 : 0 : 0}
                        </Typography>
                    </Box>
                </>
            ) : row.label === 'Purchase' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            textAlign={'center'}
                            color="primary">
                            Fr/Sa/Su
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            textAlign={'center'}
                            fontSize={14}
                            fontWeight={400}>
                            {(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined) ? item.actualData.allotments[0].ticketSetting !== null ? JSON.parse(item.actualData.allotments[0].ticketSetting).ticketFriPurCount !== "" ? JSON.parse(item.actualData.allotments[0].ticketSetting).ticketFriPurCount + '/' + JSON.parse(item.actualData.allotments[0].ticketSetting).ticketSatPurCount + '/' + JSON.parse(item.actualData.allotments[0].ticketSetting).ticketSunPurCount : 0 : 0 : 0}
                        </Typography>
                    </Box>
                </>
            ) : row.label === 'Add Purchase' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            textAlign={'center'}
                            color="primary">
                            Fr/Sa/Su
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            textAlign={'center'}
                            fontWeight={400}>
                            {(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined) ? item.actualData.allotments[0].ticketSetting !== null ? JSON.parse(item.actualData.allotments[0].ticketSetting).ticketFriAddPurCount !== "" ? JSON.parse(item.actualData.allotments[0].ticketSetting).ticketFriAddPurCount + '/' + JSON.parse(item.actualData.allotments[0].ticketSetting).ticketSatAddPurCount + '/' + JSON.parse(item.actualData.allotments[0].ticketSetting).ticketSunAddPurCount : 0 : 0 : 0}
                        </Typography>
                    </Box>
                </>
            ) : row.label === 'Room Type' ? (
                <>
                    {props.showHotelToggle ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                {row.label}
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row[row.key] ? (
                                    <Tooltip title={row[row.key]}>
                                        <span
                                            className={
                                                row.wrapAll
                                                    ? classes.wrapAll
                                                    : classes.wrapTextStyle
                                            }>
                                            {row[row.key]}
                                        </span>
                                    </Tooltip>
                                ) : (
                                    ''
                                )}
                            </Typography>
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                width: '100%',
                                backgroundColor: '#fff',
                                '& .MuiFormControl-root': { width: '100%' },
                            }}>
                            <FormControl fullWidth={false} size="small">
                                <InputLabel id="demo-simple-select-label">
                                    Room Type
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={
                                        item.selected === false
                                            ? row.hotelRoomValue
                                            : item.selected
                                    }
                                    label="Room Type"
                                    onChange={(event) =>
                                        props.onChangeHotelRoom(event, index)
                                    }>
                                    {props.asListRoomTax &&
                                        props.asListRoomTax.length > 0 &&
                                        props.asListRoomTax.map((option) => (
                                            <MenuItem
                                                key={option.value}
                                                disabled={option.value === 2 ? true : false}
                                                value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                </>
            ) : row.label === 'Check In' ? (
                props.showHotelToggle ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {row[row.key] ? (
                                <Tooltip title={row[row.key]}>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {row[row.key]}
                                    </span>
                                </Tooltip>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </Typography>
                    </Box>
                ) : item.selected === false ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {row[row.key] ? (
                                <Tooltip title={row[row.key]}>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {row[row.key]}
                                    </span>
                                </Tooltip>
                            ) : (
                                ''
                            )}
                        </Typography>
                    </Box>
                ) : item.selected === 1 ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {props.hotelKeyValue.ComplemintaryCheckin ? (
                                <Tooltip
                                    title={
                                        props.hotelKeyValue.ComplemintaryCheckin
                                    }>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {
                                            props.hotelKeyValue
                                                .ComplemintaryCheckin
                                        }
                                    </span>
                                </Tooltip>
                            ) : (
                                ''
                            )}
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {props.hotelKeyValue.ForPurchaseCheckin ? (
                                <Tooltip
                                    title={
                                        props.hotelKeyValue.ForPurchaseCheckin
                                    }>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {props.hotelKeyValue.ForPurchaseCheckin}
                                    </span>
                                </Tooltip>
                            ) : (
                                ''
                            )}
                        </Typography>
                    </Box>
                )
            ) : row.label === 'Check Out' ? (
                props.showHotelToggle ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {row[row.key] ? (
                                <Tooltip title={row[row.key]}>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {row[row.key]}
                                    </span>
                                </Tooltip>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </Typography>
                    </Box>
                ) : item.selected === false ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {row[row.key] ? (
                                <Tooltip title={row[row.key]}>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {row[row.key]}
                                    </span>
                                </Tooltip>
                            ) : (
                                ''
                            )}
                        </Typography>
                    </Box>
                ) : item.selected === 1 ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {props.hotelKeyValue.ComplimentaryCheckOut ? (
                                <Tooltip
                                    title={
                                        props.hotelKeyValue
                                            .ComplimentaryCheckOut
                                    }>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {
                                            props.hotelKeyValue
                                                .ComplimentaryCheckOut
                                        }
                                    </span>
                                </Tooltip>
                            ) : (
                                ''
                            )}
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            fontWeight={400}>
                            {props.hotelKeyValue.ForPurchaseCheckout ? (
                                <Tooltip
                                    title={
                                        props.hotelKeyValue.ForPurchaseCheckout
                                    }>
                                    <span
                                        className={
                                            row.wrapAll
                                                ? classes.wrapAll
                                                : classes.wrapTextStyle
                                        }>
                                        {
                                            props.hotelKeyValue
                                                .ForPurchaseCheckout
                                        }
                                    </span>
                                </Tooltip>
                            ) : (
                                ''
                            )}
                        </Typography>
                    </Box>
                )
            ) : row.label === 'History' ? (
                <Tooltip title="Change Log" aria-label="changelog">
                    <IconButton
                        color="primary"
                        onClick={() => props.showHistory(item)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <VisibilityOutlinedIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'Attachment' ? (
                row.showAttachmentIcon ? (
                    <Tooltip title="Attachment" aria-label="attachments">
                        <IconButton color="primary">
                            <AttachmentOutlinedIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) : null
            ) : row.label === 'SenMail' ? (
                <Tooltip title="Send" aria-label="send">
                    <IconButton
                        color="primary"
                        onClick={() => props.editSendEmail(item)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>{row.showViewIcon ?
                            <VisibilityOutlinedIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                            : <EmailIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        }
                    </IconButton>
                </Tooltip>
            ) : row.label === 'ClipBoard' ? (
                <Tooltip title="Copy To Clipboard" aria-label="copyToClipboard">
                    <IconButton
                        color="primary"
                        onClick={() => props.copyToClipboard(item)}
                        disabled={
                            !row.showClipBoardIcon ||
                            item.actualData.active == 0
                        }>
                        <ContentCopyOutlinedIcon
                            fontSize="small"
                            color={
                                row.showClipBoardIcon &&
                                    item.actualData.active == 1
                                    ? 'primary'
                                    : 'default'
                            }
                        />
                    </IconButton>
                </Tooltip>
            )
                : row.label === 'ArchiveMail' ? (
                    <Tooltip title="Archive" aria-label="archiveMail">
                        <span>
                            <IconButton
                                color="primary"
                                onClick={() => props.archiveMail(item)}
                                disabled={row.disableIcon}>
                                <ArchiveIcon
                                    fontSize="small"
                                    color={
                                        !row.disableIcon
                                            ? 'primary'
                                            : 'default'
                                    }
                                />
                            </IconButton>
                        </span>
                    </Tooltip>
                )
                    : row.label === 'SenUserMail' ? (
                        // row.showEmailIcon ?
                        <Tooltip title="Send" aria-label="send">
                            <IconButton
                                color="primary"
                                onClick={() => props.editSendEmail(item)}
                                disabled={
                                    !row.showEmailIcon || item.actualData.active == 0
                                }>
                                <EmailIcon
                                    fontSize="small"
                                    color={
                                        row.showEmailIcon && item.actualData.active == 1
                                            ? 'primary'
                                            : 'default'
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    ) : // : null
                        // <Tooltip title="Template name" aria-label="Template Name">
                        //     <IconButton
                        //         color="primary"
                        //         onClick={() => props.editTemplate(item)}

                        //     >
                        //         <TextSnippetOutlinedIcon color="primary" />
                        //     </IconButton>
                        // </Tooltip>
                        (props.moduleToShow === 'Player Hotel' && (row.label === 'First Name' || row.label === 'Last Name')) ?
                            (
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        {row.label}
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={14}
                                        fontWeight={400}>
                                        {row[row.key] ? (
                                            <Tooltip title={row[row.key]}>
                                                <span
                                                    className={
                                                        row.wrapAll
                                                            ? classes.wrapAll
                                                            : classes.wrapTextStyle
                                                    }>
                                                    {row[row.key]}
                                                </span>
                                            </Tooltip>
                                        ) : (
                                            <span>&nbsp;</span>
                                        )}
                                    </Typography>
                                </Box>
                            ) :
                            row.label === 'Shared' ||
                                (row[row.key] && row[row.key].length >= 0) ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection:
                                            row.inColumn != undefined ? 'column' : 'row',
                                        justifyContent:
                                            row.alignCenter != undefined
                                                ? row.type
                                                    ? 'left'
                                                    : 'center'
                                                : 'left',
                                        alignItems:
                                            row.alignCenter != undefined ? 'center' : 'start',
                                        flexWrap:
                                            row.wrapUp != undefined && row.wrapUp
                                                ? 'wrap'
                                                : 'nowrap',
                                    }}>
                                    {/* {row.showTemplateIcon ?
                            <Box
                                component="img"
                                className={
                                    classes.mailLogo
                                }
                                alt="air"
                                src={
                                    mailPng
                                }
                            />
                            : null} */}
                                    {row.showLabel == undefined ? (
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {row.label}
                                        </Typography>
                                    ) : null}
                                    {row.type ? (
                                        <IconButton>
                                            {row.type == 'ground' ? (
                                                <Box
                                                    component="img"
                                                    className={classes.transportLogo}
                                                    alt="ground"
                                                    src={groundSvg}
                                                />
                                            ) : (
                                                <Box
                                                    component="img"
                                                    className={classes.transportLogo}
                                                    alt="air"
                                                    src={airSvg}
                                                />
                                            )}
                                        </IconButton>
                                    ) : null}
                                    {row.showChips != undefined ? (
                                        row[row.key] ? (
                                            row[row.key].split(', ').map((chipItem) => {
                                                return (
                                                    <Chip
                                                        key={chipItem}
                                                        label={chipItem}
                                                        sx={{ mr: '4px', mb: '2px' }}
                                                    />
                                                );
                                            })
                                        ) : null
                                    ) : row.showStatusIcon != undefined ? (
                                        <Tooltip title={row[row.key] == 'Rejected' ? 'Not Approved' : row[row.key]  } aria-label={row[row.key]}>
                                            <CircleIcon
                                                fontSize="small"
                                                style={{
                                                    color:
                                                        row[row.key] == 'Pending'
                                                            ? '#F9B811'
                                                            : row[row.key] == 'Approved'
                                                                ? '#169D3C'
                                                                : '#C81020',
                                                }}
                                            />
                                        </Tooltip>
                                    ) : row.showSwitch != undefined ? (
                                        <Switch
                                            disabled={
                                                props.modPermission &&
                                                    props.modPermission == FULL_PERMISSION
                                                    ? false
                                                    : true
                                            }
                                            checked={
                                                row[row.key] != undefined ? row[row.key] : false
                                            }
                                            onChange={(e) =>
                                                props.onSwitchToggle(e, index, item)
                                            }
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            color={'success'}
                                        />
                                    ) : // <IOSSwitch
                                        //     sx={{
                                        //         m: 1,
                                        //     }}
                                        //     checked={
                                        //         row[row.key]
                                        //     }
                                        //     onChange={(
                                        //         e
                                        //     ) =>
                                        //         props.onSwitchToggle(
                                        //             e,
                                        //             index,
                                        //             item
                                        //         )
                                        //     }
                                        // />
                                        row.inHTML != undefined ? (
                                            <Typography
                                                variant="h4"
                                                flexGrow={1}
                                                fontSize={14}
                                                fontWeight={400}>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: row[row.key],
                                                    }}></span>
                                            </Typography>
                                        ) : row.asList !== undefined ? (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                }}>
                                                <Stack
                                                    direction="row"
                                                    spacing={-1.8}
                                                    flexWrap="wrap">
                                                    {row[row.key].map((rowItem, rowIndex) => {
                                                        return (
                                                            <IconButton
                                                                key={`profile_${rowIndex}`}
                                                                size="small"
                                                                aria-label="account of current user"
                                                                aria-controls="primary-search-account-menu"
                                                                aria-haspopup="true"
                                                                color="inherit"
                                                                onClick={() =>
                                                                    props.deleteConnection(rowItem)
                                                                }>
                                                                <Badge
                                                                    overlap="circular"
                                                                    anchorOrigin={{
                                                                        vertical: 'bottom',
                                                                        horizontal: 'left',
                                                                    }}
                                                                    badgeContent={
                                                                        <RemoveCircleIcon
                                                                            fontSize="small"
                                                                            sx={{ color: 'red' }}
                                                                            className={
                                                                                classes.setScale
                                                                            }></RemoveCircleIcon>
                                                                    }>
                                                                    <ProfileInitial
                                                                        data={rowItem}
                                                                        showOnlyInitial={true}
                                                                        navigationScreen={
                                                                            'changeUser'
                                                                        }
                                                                    />
                                                                    {/* <GroupAvatar
                                                        data={rowItem}
                                                    /> */}
                                                                </Badge>
                                                            </IconButton>
                                                        );
                                                    })}
                                                </Stack>

                                                {row.showAdd != undefined && (
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => props.addConnection(item)}
                                                        disabled={
                                                            item.disableRow != undefined
                                                                ? item.disableRow
                                                                : false
                                                        }>
                                                        <AddCircleRoundedIcon
                                                            fontSize="small"
                                                            color={
                                                                item.disableRow != undefined
                                                                    ? 'default'
                                                                    : 'primary'
                                                            }
                                                        />
                                                    </IconButton>
                                                )}
                                                {row.showAddLinkedWith != undefined && (
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() =>
                                                            props.addConnectionLinkedWith(item)
                                                        }
                                                        disabled={
                                                            item.disableRow != undefined
                                                                ? item.disableRow
                                                                : false
                                                        }>
                                                        <AddCircleRoundedIcon
                                                            fontSize="small"
                                                            color={
                                                                item.disableRow != undefined
                                                                    ? 'default'
                                                                    : 'primary'
                                                            }
                                                        />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        ) : (
                                            <Typography
                                                variant="h4"
                                                flexGrow={1}
                                                fontSize={14}
                                                fontWeight={400}>
                                                {row[row.key] ? (
                                                    row.addLink ? (
                                                        <Link
                                                            component="button"
                                                            variant="body2"
                                                            onClick={() => props.viewPage(item)}
                                                            className={classes.wrapTextStyle}>
                                                            {row[row.key]}
                                                        </Link>
                                                    ) : row.showTooltip != undefined ? (
                                                        <Tooltip title={row[row.key]}>
                                                            <span
                                                                className={
                                                                    row.wrapAll
                                                                        ? classes.wrapAll
                                                                        : classes.wrapTextStyle
                                                                }>
                                                                {row[row.key]}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        <>
                                                            <Tooltip title={row[row.key]} >
                                                                {/* <span
                                                        className={
                                                            row.isSent
                                                                ? classes.wrapTextSmallSize
                                                                : classes.wrapTextStyle
                                                        }>
                                                        {row[row.key]}
                                                    </span> */}
                                                                {row.key === 'participant' ? (
                                                                    <span
                                                                        className={
                                                                            row.isSent
                                                                                ? classes.wrapTextSmallSize
                                                                                : classes.wrapTextStyle
                                                                        }>
                                                                        {row[row.key].search(
                                                                            'DELETED'
                                                                        ) !== -1 && (
                                                                                <span
                                                                                    style={{
                                                                                        color: 'red',
                                                                                    }}>{`DELETED`}</span>
                                                                            )}
                                                                        {row[row.key].replace(
                                                                            'DELETED',
                                                                            ''
                                                                        )}
                                                                    </span>
                                                                ) : row.key ===
                                                                    'appNotification' ? (
                                                                    <><Box component="div" sx={{ cursor: "pointer" }} onClick={() => item.actualData?.appNotificationID ? props.handleAppNotificationClick(item.actualData) : null}><div
                                                                        className={
                                                                            classes.wrapTextFullStyle
                                                                        }>
                                                                        {row[row.key]} {" "}
                                                                        {row[row.statusKey] === "pending" ?
                                                                            <Typography
                                                                                variant="span"
                                                                                sx={{
                                                                                    color: 'white',
                                                                                    backgroundColor: '#F9B811',
                                                                                    borderRadius: 10,
                                                                                    textAlign: 'center',
                                                                                    paddingY: '3px',
                                                                                    paddingX: '10px'
                                                                                }}>Pending</Typography> : row[row.statusKey] === "approved" ? <Typography
                                                                                    variant="span"
                                                                                    sx={{
                                                                                        color: 'white',
                                                                                        backgroundColor: 'green',
                                                                                        borderRadius: 10,
                                                                                        textAlign: 'center',
                                                                                        paddingY: '3px',
                                                                                        paddingX: '10px'

                                                                                    }}>
                                                                                    Approved
                                                                                </Typography> : row[row.statusKey] === "rejected" ? <Typography
                                                                                    variant="span"
                                                                                    sx={{
                                                                                        color: 'white',
                                                                                        backgroundColor: 'red',
                                                                                        borderRadius: 10,
                                                                                        textAlign: 'center',
                                                                                        paddingY: '3px',
                                                                                        paddingX: '10px'
                                                                                    }}>
                                                                                    Not Approve
                                                                                </Typography> : null}
                                                                    </div>
                                                                        <div>{Helper.FormatDateTime(item.actualData.createdDate)}  {item.actualData.submittedBy}</div></Box></>

                                                                ) : (
                                                                    <span
                                                                        className={
                                                                            row.isSent
                                                                                ? classes.wrapTextSmallSize
                                                                                : classes.wrapTextStyle
                                                                        }>
                                                                        {row[row.key]}
                                                                    </span>
                                                                )}
                                                            </Tooltip>
                                                            {row.showEmail && row.toEmail ? row.showEmailIcons ? (
                                                                <Box>
                                                                <IconButton color="primary" sx={{padding:0}}>
                                                                    <EmailIcon
                                                                        fontSize="small"
                                                                        color={ 'primary'}
                                                                    />
                                                                    <Typography
                                                                        fontSize={11}
                                                                        sx={{
                                                                            wordBreak: 'break-word', 
                                                                            pl:1
                                                                        }}>
                                                                        <a
                                                                            href={`mailto:${row.toEmail}`}>
                                                                            {' '}
                                                                            {row.toEmail}{' '}
                                                                        </a>
                                                                    </Typography>
                                                                </IconButton>
                                                                </Box>
                                                            ) : (<Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                    paddingRight:'5px'
                                                                }}>
                                                                <a
                                                                    href={`mailto:${row.toEmail}`}>
                                                                    {' '}
                                                                    {row.toEmail}{' '}
                                                                </a>
                                                            </Typography>) : null}
                                                            {row.showContactNo && row.toContactNo ? (
                                                                <Box>
                                                                    <IconButton color="primary" sx={{padding:0}}>
                                                                        <LocalPhoneOutlinedIcon
                                                                            fontSize="small"
                                                                            color={ 'primary'}
                                                                        />
                                                                        <Typography
                                                                            fontSize={11}
                                                                            sx={{
                                                                                wordBreak: 'break-word',
                                                                                pl:1
                                                                            }}>
                                                                                <a href={`tel:${row.toContactNo}`}> {row.toContactNo}</a>
                                                                            
                                                                        </Typography>
                                                                    </IconButton>
                                                                </Box>
                                                            ) : null}
                                                            {row.showBulkUserName && row.toBulkUserName ? (
                                                                <Typography
                                                                    fontSize={14}
                                                                    sx={{
                                                                        wordBreak: 'break-word',
                                                                        paddingTop: 2
                                                                    }}> 
                                                                        {row.toBulkUserName} 
                                                                </Typography>
                                                            ) : null}
                                                            {row.showEventType &&
                                                                row.showEventType !== '' ? (
                                                                <Typography fontSize={11}>
                                                                    {row.eventType}{' '}
                                                                </Typography>
                                                            ) : null}
                                                        </>
                                                    )
                                                ) : (
                                                    ''
                                                )}
                                            </Typography>
                                        )}
                                </Box>
                            ) : null}
        </Box>
    );
};
export default DataListRowItem;
